import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { Route, Switch } from "react-router-dom";
import SEO from "../../../UI/SEO/SEO";
import CampaignTemplateList from "./CampaignTemplateList";
import { getCampaignBaseRoute, getCampaignTemplatePath, } from "../CampaignRoutes";
import CampaignTemplateDetail from "./CampaignTemplateDetail";
import CampaignTemplateNew from "./CampaignTemplateNew";
import CampaignTemplateEdit from "./CampaignTemplateEdit";
import { getPreBaseRoute } from "../../../../../components";
import CampaignTemplateCopy from "./CampaignTemplateCopy";
// Private
const getCampaignTemplateBaseRoute = () => getCampaignBaseRoute() + "/template";
const getCampaignTemplateDetailRoute = () => getCampaignTemplateBaseRoute() + "/detail";
const getCampaignTemplateListRoute = () => getCampaignTemplateBaseRoute() + "/list";
const getCampaignTemplateEditRoute = () => getCampaignTemplateBaseRoute() + "/edit";
const getCampaignTemplateNewRoute = () => getCampaignTemplateBaseRoute() + "/new";
const getCampaignTemplateCopyRoute = () => getCampaignTemplateBaseRoute() + "/copy";
const getCampaignTemplateDetailBasePath = (virtualizedAppName) => {
    return getCampaignTemplatePath({ virtualizedAppName }) + "/detail";
};
export const getCampaignTemplateListPath = (virtualizedAppName) => {
    return getCampaignTemplatePath({ virtualizedAppName }) + "/list";
};
export const getCampaignTemplateDetailPath = (id, virtualizedAppName) => {
    return id == null
        ? getCampaignTemplateListPath(virtualizedAppName)
        : getCampaignTemplateDetailBasePath(virtualizedAppName) + `/${id}`;
};
export const getCampaignTemplateNewPath = (virtualizedAppName) => {
    return getCampaignTemplatePath({ virtualizedAppName }) + "/new";
};
const getCampaignTemplateEditBasePath = (virtualizedAppName) => {
    return getCampaignTemplatePath({ virtualizedAppName }) + "/edit";
};
const getCampaignTemplateCopyBasePath = (virtualizedAppName) => {
    return getCampaignTemplatePath({ virtualizedAppName }) + "/copy";
};
export const getCampaignTemplateEditPath = (id, virtualizedAppName) => {
    return id == null
        ? getCampaignTemplateListPath(virtualizedAppName)
        : getCampaignTemplateEditBasePath(virtualizedAppName) + `/${id}`;
};
export const getCampaignTemplateCopyPath = (id, virtualizedAppName) => {
    return id == null
        ? getCampaignTemplateListPath(virtualizedAppName)
        : getCampaignTemplateCopyBasePath(virtualizedAppName) + `/${id}`;
};
const CampaignTemplateRoutes = () => (_jsxs(_Fragment, { children: [_jsx(SEO, { title: "Campaigns" }), _jsxs(Switch, { children: [_jsx(Route, { component: CampaignTemplateDetail, path: getPreBaseRoute() + getCampaignTemplateDetailRoute() + "/:id" }), _jsx(Route, { component: CampaignTemplateEdit, path: getPreBaseRoute() + getCampaignTemplateEditRoute() + "/:id" }), _jsx(Route, { component: CampaignTemplateCopy, path: getPreBaseRoute() + getCampaignTemplateCopyRoute() + "/:id" }), _jsx(Route, { component: CampaignTemplateList, path: getPreBaseRoute() + getCampaignTemplateListRoute() }), _jsx(Route, { component: CampaignTemplateNew, path: getPreBaseRoute() + getCampaignTemplateNewRoute() })] })] }));
export default CampaignTemplateRoutes;
